import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import BannerBoxDesktop from '@/components/widgets/BannerBox/variants/BannerBoxDesktop.vue';
import BannerBoxMobile from '@/components/widgets/BannerBox/variants/BannerBoxMobile.vue';
import type { EditionStageType } from '@/types/backend';
import { EditionStage } from '@/types/backend';
import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints';
import { computed } from 'vue';
import useEditionStageStore from '@/stores/EditionStage';
import { storeToRefs } from 'pinia';

type Props = {
    homeStatesToShow?: EditionStageType[];
};

type Variant = typeof BannerBoxDesktop | typeof BannerBoxMobile;

export default /*@__PURE__*/_defineComponent({
  __name: 'BannerBox',
  props: {
    homeStatesToShow: { default: () => Object.values(EditionStage) }
  },
  setup(__props: any) {

const props = __props;

const PUBLIC_PATH: string = process.env.VUE_APP_PUBLIC_PATH ?? '/';

const editionStageStore = useEditionStageStore();

const { editionStage } = storeToRefs(editionStageStore);

const showBanner = computed<boolean>(() => props.homeStatesToShow.includes(editionStage.value));

const breakpoints = useVuetifyBreakpoints();
const isMobile = breakpoints.smallerOrEqual('md');

const variant = computed<Variant>(() => isMobile.value ? BannerBoxMobile : BannerBoxDesktop);

return (_ctx: any,_cache: any) => {
  return (showBanner.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(variant.value), _mergeProps({ key: 0 }, _ctx.$attrs, { "public-path": _unref(PUBLIC_PATH) }), null, 16, ["public-path"]))
    : _createCommentVNode("", true)
}
}

})